import React,{useState} from 'react';
import firebase from '../firebase';
import {Formik, Form, Field, ErrorMessage} from 'formik';
import {string, object} from 'yup';
import {Link} from 'react-router-dom';
import ReactFlagsSelect from 'react-flags-select';
import MessageModal from './MessageModal';
import RemoveAccountModal from './RemoveAccountModal';
import {Row, Col} from 'react-bootstrap';
import DatePickerField from './DatePickerField';
const SelectCountry = ({name,id,onSelect,defaultCountry})=>{
    return(

    <ReactFlagsSelect
        name={name}
        id={id}
        className="form-control"
        searchable={true} 
        onSelect = {(val)=>{
            onSelect(name,val);
        }}
        defaultCountry={defaultCountry}
    />
    )
}

const Profile = (props) => {
    const [modalVisible, setModal] = useState(false);
    const [removeAccountModalVisible, setRemoveAccountModal] = useState(false);
    const closeModal = () =>{
        setModal(false);
        window.location.reload();
    }
    const showModal = () =>{
        setModal(true);
    }
    const closeRemoveAccountModal = () =>{
        setRemoveAccountModal(false);
    }
    const showRemoveAccountModal = (e) =>{
        e.preventDefault();
        setRemoveAccountModal(true);
    }
    const handleRemoveAccount = ()=>{
        const user = firebase.auth().currentUser;
        firebase.firestore().collection('users').doc(user.uid).delete().then(()=>{
            console.log('DB user data removed');
            user.delete().then(()=>{
                firebase.analytics().logEvent('account_remove',{id:user.uid});
                console.log('user account removed');
            });
        }).catch((error)=>{
            console.log(error);
            alert('Error with removing account - please refresh and log in again')
            console.log('error removing the user');
        });

    }
    let maxBirthDate = new Date();
    maxBirthDate.setFullYear(maxBirthDate.getFullYear()-16);
    return ( 
        <div className="container col-md-10 page-container faq-container">
            <MessageModal show={modalVisible} closeModal={closeModal} message={"Profile successfully modified"} title="Success"/>
            <RemoveAccountModal show={removeAccountModalVisible} closeModal={closeRemoveAccountModal} removeAccount={handleRemoveAccount} message={"Profile successfully modified"} title="Success"/>
            <h3 className="page-title">
                Profile
            </h3>
            <div className="profile-wrapper mobile-container">
            <Formik
                initialValues={{
                    email:props.user.email,
                    firstName:props.user.firstName,
                    lastName:props.user.lastName,
                    country:props.user.country,
                    birthdate: props.user.birthdate ? props.user.birthdate.seconds*1000 : null
                }}
                validationSchema={object({
                    firstName: string()
                    .required('Required'),
                    lastName: string()
                    .required('Required'),
                    country: string()
                    .required('Required'),
                })}
                onSubmit={(values,{setSubmitting})=>{
                    const obj = {firstName:values.firstName, lastName:values.lastName,country:values.country,fullName:values.firstName+ " "+values.lastName, birthdate:values.birthdate}
                    firebase.firestore().collection('users').doc(props.user.uid).update(obj).then((data)=>{
                        showModal();
                        setSubmitting(false);
                        //update age
                        const analytics = firebase.analytics();
                        if(obj.birthdate && obj.birthdate!==''){
                            var diff_ms = Date.now() - obj.birthdate.getTime();
                            var age_dt = new Date(diff_ms); 
                            const age =  Math.abs(age_dt.getUTCFullYear() - 1970);
                            analytics.setUserProperties({age:age});
                        }
                    }).catch((err)=>{
                        console.log(err);
                    });
                }}
            >
              {({
                values,
                handleSubmit,
                setFieldValue,
                errors,
                isSubmitting
              })=>(
                <Form className="register-form">
                <Row >
                    <Col xs={12} md={6} className=" label-container form-left">
                        <Row className="mr-md-0">
                            <Col xs={6} md={8} className="pl-0 label-container">
                            <label htmlFor="firstName">First Name</label>
                            </Col>
                            <Col xs={6} md={4} className="form-error pr-0 pl-0">
                                <ErrorMessage name="firstName"/>
                            </Col>
                        </Row>
                        <Row className="mr-md-0"><Field id="firstName" name="firstName" type="text" className="form-control" placeholder="Enter first name..."/></Row>
                    </Col>
                    <Col xs={12} md={6} className=" label-container form-group">
                        <Row className="ml-md-0">
                            <Col xs={6} md={8} className="pl-0 label-container">
                                <label htmlFor="lastName">Last Name</label>
                            </Col>
                            <Col xs={6} md={4} className="form-error pr-0 pl-0">
                                <ErrorMessage name="lastName"/>
                            </Col>
                        </Row>
                        <Row className="ml-md-0"><Field id="lastName" name="lastName" type="text" className="form-control" placeholder="Enter last name..."/></Row>
                    </Col>
                </Row>
                <div className="form-group">
                    <Row>
                        <Col xs={3}  className="pl-0 label-container">
                        <label htmlFor="email">Email</label>
                        </Col>
                        <Col xs={9}  className="form-error pr-0">
                            <ErrorMessage name="email"/>
                        </Col>
                    </Row>
                    <Row ><Field disabled id="email" name="email" type="text" className="form-control" placeholder="Enter a valid email..."/></Row>
                </div>
                <div className="form-group">
                    <Row>
                        <Col xs={8}  className="pl-0 label-container">
                        <label htmlFor="country">Country</label>
                        </Col>
                        <Col xs={4}  className="form-error pr-0">
                            <ErrorMessage name="country"/>
                        </Col>
                    </Row>
                    <Row>
                        <SelectCountry
                        className="form-control"
                        name="country"
                        id="country"
                        onSelect={setFieldValue}
                        defaultCountry={values.country}
                        />
                    </Row>
                </div>
                <div className="form-group">
                    <Row>
                        <Col xs={8}  className="pl-0 label-container">
                        <label htmlFor="birthdate">Birthdate</label>
                        </Col>
                        <Col xs={4}  className="form-error pr-0">
                            <ErrorMessage name="birthdate"/>
                        </Col>
                    </Row>
                    <Row>
                    <DatePickerField
                            className="form-control"
                            name="birthdate"
                            id="birthdate"
                            onChange={setFieldValue}
                            value={values.birthdate}
                            showTimeSelect={false}
                            clearable={true}
                            maxDate={maxBirthDate}
                            showMonthDropdown={true}
                            showYearDropdown={true}
                            dateFormat={"MMMM d, yyyy"}
                        />
                    </Row>
                </div>

                <Row className="form-group">
                    <button className="btn btn-primary mx-auto" type="submit" disabled={isSubmitting}>Apply Changes</button>
                </Row>
                <Row className="text-center">
                    <Link className="have-account" to="/password-reset">Reset password</Link>
                </Row>
                <Row className="text-center">
                    <Link className="have-account remove-account" to="." onClick={showRemoveAccountModal}>Remove account</Link>
                </Row>
                </Form>
              )}  
            </Formik>
            </div>
        </div>
     );
}
 
export default Profile;